module.exports = __webpack_public_path__ + "static/media/women-retail-img.f9861ca5.jpg";